import { put, call, takeEvery, select } from 'redux-saga/effects'
import { get } from 'lodash'

import { SAVE_RICH_CHECKOUT_ORDER_REQUESTED, saveRichCheckoutOrder, RICH_CHECKOUT_ORDER_COMPLETED } from '../../actions/richCheckout/order'

import { createOrder } from '../../models/order/create'

import { updatePaymentOnOrderRichCheckoutSaga } from './addPayment'
import { updateUserNotesSaga } from './patchOrder'

import { customHistory } from '../../stores'
import { makeGetOrder } from '../../selectors/order'
import { orderDetailsRequested, startTabWithRemotePayment } from '../../actions/order'

const directTo = (method = 'push', path) => {
  if (path === undefined) return

  customHistory[method](path)
}

const getOrder = makeGetOrder()

export function* _saveRichCheckoutOrder(params = {}) {
  const args = {
    lineItems: get(params, 'payload.lineItems'),
    orderNumber: get(params, 'payload.orderNumber'),
    paymentCompleted: true,
    paymentType: 'mobile_app',
    uuid: get(params, 'payload.uuid'),
  }

  const order = yield createOrder(args)

  yield put(saveRichCheckoutOrder(order))
}

export function* watchSaveRichCheckoutOrder() {
  yield takeEvery(SAVE_RICH_CHECKOUT_ORDER_REQUESTED, _saveRichCheckoutOrder)
}

export function* richCheckoutOrderCompletedSaga(params = {}) {
  const orderId = params?.payload?.orderId

  // FIXME (@westinschepper): user notes should be passed in the QR Code.
  yield updateUserNotesSaga(params)
  yield put(orderDetailsRequested(orderId))
  yield call(directTo, 'replace', `/tabs/${orderId}`)

  /**
   * TODO (@westinschepper): Early returning until we can implement support
   * for the order user notes with pay now rich checkout orders.
   */
  return

  // NOTE (westinschepper): This is temporary
  // if (params?.payload?.isNewOrder) {
  //   let paymentPreference = {
  //     "customerId": null,
  //     "token": null,
  //     "paymentType": 28,
  //     "userAttributes": null,
  //     "externalRefId": "credit card",
  //     "shortDescription": "Mobile Pay",
  //     "salesEventId": null,
  //     "nickname": null,
  //     "uuid": null,
  //     "paymentDisplay": "Mobile Pay"
  //   }

  //   yield put(startTabWithRemotePayment({ orderId, userNotes, exemptionOverrides: { applySalesTax: true, applyServiceFee: true }, paymentPreference }))
  // } else {
  //   let payments = { amountInCents: order?.amountInCents, paymentType: 'credit_card' }
  //   let payload = {
  //     orderId,
  //     payments,
  //     userAttributes: order.userAttributes,
  //     userName: order.userName,
  //   }

  //   yield updatePaymentOnOrderRichCheckoutSaga({ payload })
  // }

  // NOTE (@westinschepper): This is temporary
  // yield call(directTo, 'replace', '/tabs')
}

export function* watchRichCheckoutOrderCompleted() {
  yield takeEvery(RICH_CHECKOUT_ORDER_COMPLETED, richCheckoutOrderCompletedSaga)
}
